<div class="card mb-5">
  <div class="card-header">
    <h3>Histórico de Retenciones</h3>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col" id="list-container">

        <h5>Filtrar</h5>

        <div class="row" style="margin-top: 1em;" id="options-other-filters">

          <div class="col-sm form-group">
            <label for="search" class="form-label">Buscar por constancia, proveedor o NIT</label>
            <div class="input-group">
              <input
                type="text"
                id="search"
                name="search"
                [(ngModel)]="search"
                placeholder="Ingresa constancia, proveedor o NIT..."
                class="form-control">

              <button class="btn btn-primary" (click)="searching()">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>

          <div class="col-sm form-group">
            <label for="startDate" class="form-label">Fecha Inicio</label>
            <input
              type="date"
              name="startDate"
              id="startDate"
              [(ngModel)]="startDate"
              (change)="checkDateValue()"
              class="form-control">
          </div>

          <div class="col-sm form-group">
            <label for="endDate" class="form-label">Fecha Final</label>
            <input
              type="date"
              name="endDate"
              id="endDate"
              min="{{startDate}}"
              [(ngModel)]="endDate"
              (change)="checkDateValue()"
              class="form-control">
          </div>

        </div>

        <div class="row mt-3">

          <div class="col-sm form-group">
            <label for="typeFilter" class="form-label">Tipo</label>
            <select
              id="typeFilter"
              name="typeFilter"
              [(ngModel)]="typeFilter"
              (change)="searching()"
              class="form-control">
              <option value="">Todos</option>
              <option value="ISR">ISR</option>
              <option value="IVA">IVA</option>
            </select>
          </div>

          <div class="col-sm form-group">
            <label for="issuedFilter" class="form-label">Movimiento</label>
            <select
              id="issuedFilter"
              name="issuedFilter"
              [(ngModel)]="issuedFilter"
              (change)="searching()"
              class="form-control">
              <option value="">Todas</option>
              <option value="true">Percibidos</option>
              <option value="false">Retenidos</option>
            </select>
          </div>

          <div class="col-sm form-group">
            <label for="constancyFilter" class="form-label">Constancia</label>
            <input
              type="text"
              id="constancyFilter"
              name="constancyFilter"
              [(ngModel)]="constancyFilter"
              (input)="searching()"
              placeholder="Filtrar por constancia..."
              class="form-control">
          </div>

        </div>

        <div class="table-responsive" style="margin-bottom: 0; overflow-y: inherit; max-height: none;">
          <table class="table table-striped" style="margin-bottom: 0;">
            <thead>
              <tr class="tr-middle">
                <th class="ta">Fecha</th>
                <th class="ta">Fecha Ingreso</th>
                <th class="ta">Tipo</th>
                <th class="ta">Movimiento</th>
                <th class="ta">Constancia</th>
                <th class="ta">NIT</th>
                <th>Proveedor / Cliente</th>
                <th class="ta">Total Retención</th>
                <th class="ta">Acciones</th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngFor="let withholding of pagination.filter">
                <tr class="tr-middle">
                  <td class="ta">
                    {{ withholding.date | date: 'yyyy/MM/dd' }}
                  </td>

                  <td class="ta">
                    {{ withholding.creationDate | date: 'yyyy/MM/dd' }}
                  </td>

                  <td class="ta">
                    <span class="badge bg-info">
                      {{ withholding.type }}
                    </span>
                  </td>

                  <td class="ta">
                    <span
                      class="badge"
                      [ngClass]="withholding.issued ? 'bg-success' : 'bg-secondary'">
                      {{ withholding.issued ? 'Percibido' : 'Retenido' }}
                    </span>
                  </td>

                  <td class="ta">
                    {{ withholding.constancy || 'Sin constancia' }}
                  </td>

                  <td class="ta">
                    {{ withholding.vendorNit || 'CF' }}
                  </td>

                  <td class="limit-td-100">
                    {{ withholding.vendorName || 'Sin nombre' }}
                  </td>

                  <td class="ta">
                    {{ withholding.totalRetention | currency:'Q' }}
                  </td>
                  <td class="ta">
                    <div
                      class="container-superposition"
                      *ngIf="!withholding.annulment"
                      title="Anular">

                      <div
                        class="element-superposition"
                        *ngIf="waitingFor?.id === withholding.id">

                        <span>¿Está seguro que desea anular esta retención?</span>

                        <span class="a-container">
                          <span class="a-hover" (click)="resetAnnulmentDiv()">
                            <i class="fa fa-ban"></i> NO
                          </span>

                          <span class="a-hover text-danger" (click)="confirmAnnulment(withholding)">
                            <i class="fa fa-trash"></i> SÍ
                          </span>
                        </span>
                      </div>

                      <span class="clickeable text-danger" (click)="showAnnulmentWarning(withholding)">
                        <i *ngIf="!annulling[withholding.id]" class="fa fa-ban"></i>
                        <span
                          *ngIf="annulling[withholding.id]"
                          class="spinner-border spinner-border-sm"
                          aria-hidden="true">
                        </span>
                      </span>
                    </div>

                    <span *ngIf="withholding.annulment" class="badge bg-danger">
                      Anulada
                    </span>
                  </td>
                </tr>
              </ng-container>

              <tr *ngIf="pagination.filter.length == 0">
                <td colspan="9" class="ta" style="color: gray">
                  <i class="fa fa-circle-info"></i>
                  No se encontraron retenciones en las fechas seleccionadas
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-pagination-custom [elements]="pagination"></app-pagination-custom>

      </div>
    </div>
  </div>
</div>